import { Nomenclature } from "@/types";
import { IDataProvider } from "@/store";

export interface INomenclatureState {
  nomenclature: Nomenclature | null;
  nomenclatures: Nomenclature[] | null;
  dataProvider: IDataProvider<Nomenclature>;
}

export const state: INomenclatureState = {
  nomenclature: null,
  nomenclatures: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
